/* global axios */
import ApiClient from '../ApiClient';

class EvolutionConnectionApi extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_connection`);
  }

  connect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/connect_evolution`);
  }

  disconnect(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/disconnect_evolution`);
  }
}

export default new EvolutionConnectionApi();
